import axios from "axios";
import YAML from "yaml";
import { CATEGORY_LIST_URL } from "@/settings/categoryListURL";

const useCategoryList = {
    methods: {
        async loadCategoryList() {
            const { data } = await axios.get(CATEGORY_LIST_URL);
            const { categoryList } = YAML.parse(data);
            return categoryList;
        },
    },
};

export default useCategoryList;
